'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function CommunityPage() {
  const { theme } = useTheme()
  const isDark = theme === 'dark'

  const bg = isDark ? '#0f172a' : '#f4f7fb'
  const ink = isDark ? '#e8f0fb' : '#0a1f3a'
  const secondary = isDark ? '#94a3b8' : '#6b7684'
  const card = isDark ? '#1e2a3d' : '#ffffff'
  const border = isDark ? '#2c3a52' : '#e9eff7'

  const boards = [
    {
      href: '/community/free-board',
      title: '자유게시판',
      desc: '자유롭게 이야기를 나누는 공간입니다.',
    },
    {
      href: '/community/inquiry',
      title: '문의게시판',
      desc: '버그 제보, 기능 요청, 불편사항을 알려주세요.',
    },
  ]

  return (
    <div style={{ background: bg, minHeight: '100vh', padding: '32px 20px 80px' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <h1 style={{ font: '700 22px/30px sans-serif', color: ink, margin: '0 0 4px' }}>
          커뮤니티
        </h1>
        <p style={{ font: '400 13px/20px sans-serif', color: secondary, margin: '0 0 24px' }}>
          프리다이버들과 소통하고 정보를 공유하세요.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {boards.map(b => (
            <Link
              key={b.href}
              href={b.href}
              style={{
                display: 'block',
                background: card,
                boxShadow: `inset 0 0 0 1px ${border}`,
                borderRadius: 14,
                padding: '16px 20px',
                textDecoration: 'none',
              }}
            >
              <p style={{ font: '600 15px/22px sans-serif', color: ink, margin: '0 0 4px' }}>
                {b.title}
              </p>
              <p style={{ font: '400 13px/20px sans-serif', color: secondary, margin: 0 }}>
                {b.desc}
              </p>
            </Link>
          ))}
        </div>

        <div
          style={{
            marginTop: 24,
            background: card,
            boxShadow: `inset 0 0 0 1px ${border}`,
            borderRadius: 14,
            padding: '16px 20px',
          }}
        >
          <p style={{ font: '600 14px/22px sans-serif', color: ink, margin: '0 0 8px' }}>
            이용 안내
          </p>
          <ul
            style={{
              font: '400 13px/22px sans-serif',
              color: secondary,
              margin: 0,
              paddingLeft: 0,
              listStyle: 'none',
            }}
          >
            <li>로그인이 필요한 서비스입니다</li>
            <li>상호 존중하는 대화 문화를 만들어주세요</li>
            <li>상업적 광고는 금지됩니다</li>
            <li>건전한 프리다이빙 문화를 함께 만들어가요</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
